export const privacyPolicyContentAr = {
    title: "سياسة الخصوصية",
    subtitle: "سياسة الخصوصية لشركة Bitsclan IT Solutions",
    metaTitle: "سياسة الخصوصية | حماية بياناتك وحقوقك | حلول تكنولوجيا المعلومات Bitsclan",
    intro:
        "في شركة Bitsclan IT Solutions، نولي احترامًا كبيرًا لخصوصيتك. توضح هذه السياسة كيفية جمعنا للبيانات الشخصية التي نستخدمها، وكيفية استخدامها، والإجراءات التي نتخذها لحماية معلوماتك. من خلال الوصول إلى موقعنا الإلكتروني أو استخدام خدماتنا، فإنك توافق على جمع واستخدام بياناتك وفقًا لهذه السياسة.",
    sections: [
        {
            heading: "1. المعلومات التي نجمعها",
            points: [
                {
                    label: "المعلومات الشخصية",
                    description:
                        "الاسم، تفاصيل الاتصال، عنوان البريد الإلكتروني، وأي معلومات أخرى تقدمها طواعية من خلال نماذجنا أو قنوات الاتصال لدينا.",
                },
                {
                    label: "المعلومات الفنية",
                    description:
                        "عنوان الـ IP، نوع المتصفح، نظام التشغيل، وبيانات الجهاز عند زيارتك لموقعنا الإلكتروني.",
                },
                {
                    label: "بيانات الاستخدام",
                    description:
                        "المعلومات المتعلقة بأنشطتك على موقعنا، بما في ذلك كيفية تفاعلك مع خدماتنا، مما يساعدنا في تحسين تجربة المستخدم.",
                },
            ],
        },
        {
            heading: "2. كيف نستخدم معلوماتك",
            points: [
                {
                    label: "لتقديم وتحسين خدماتنا",
                    description:
                        "تساعدنا معلوماتك في تقديم وتحسين خدماتنا، وضمان تلبية احتياجاتك.",
                },
                {
                    label: "التواصل",
                    description:
                        "قد نرسل لك تحديثات بخصوص الخدمات، تغييرات في الشروط، أو ردود على استفساراتك.",
                },
                {
                    label: "الأمان والامتثال",
                    description:
                        "نستخدم معلوماتك لضمان أمان خدماتنا والامتثال للالتزامات القانونية.",
                },
                {
                    label: "التسويق",
                    description:
                        "بموافقتك، قد نرسل لك محتوى ترويجي أو معلومات عن الخدمات التي نعتقد أنها ستهمك.",
                },
            ],
        },
        {
            heading: "3. أمان البيانات",
            content:
                "نقوم بتنفيذ تدابير أمنية قياسية لحماية معلوماتك الشخصية. وتشمل هذه التدابير تخزين البيانات بشكل آمن، والتشفير، وضوابط الوصول الصارمة. على الرغم من أننا نسعى لحماية بياناتك، إلا أنه لا يمكن لأي نظام ضمان الأمان التام.",
        },
        {
            heading: "4. مشاركة بياناتك",
            content:
                "نحن لا نبيع أو نؤجر أو نتاجر بمعلوماتك الشخصية. ومع ذلك، قد نشارك المعلومات مع أطراف ثالثة موثوقة تساعد في تشغيل أعمالنا، مثل معالجي المدفوعات، خدمات السحابة، وشركاء التسويق. هذه الأطراف الثالثة ملزمة بحماية بياناتك واستخدامها فقط بما يتوافق مع تقديم خدماتهم.",
        },
        {
            heading: "5. حقوقك",
            content:
                "لديك الحق في الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها. إذا كنت ترغب في ممارسة هذه الحقوق، أو إذا كان لديك أي استفسارات حول بياناتك، يرجى الاتصال بنا باستخدام المعلومات أدناه.",
        },
        {
            heading: "6. ملفات تعريف الارتباط (الكوكيز)",
            content:
                "يستخدم موقعنا الإلكتروني ملفات تعريف الارتباط لتحسين تجربة المستخدم. ملفات تعريف الارتباط هي ملفات نصية صغيرة يتم تخزينها على جهازك تساعدنا في التعرف على تفضيلاتك. يمكنك إدارة إعدادات الكوكيز من خلال متصفحك، ولكن يرجى ملاحظة أن تعطيل الكوكيز قد يؤثر على قدرتك في استخدام بعض ميزات موقعنا الإلكتروني.",
        },
        {
            heading: "7. التغييرات في هذه السياسة",
            content:
                "قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سيتم نشر أي تغييرات على هذه الصفحة مع التاريخ المعدل. نوصي بمراجعة هذه السياسة بشكل دوري للبقاء على اطلاع بكيفية حماية معلوماتك.",
        },
        {
            heading: "8. اتصل بنا",
            content:
                "إذا كان لديك أي أسئلة أو استفسارات حول سياسة الخصوصية أو كيفية التعامل مع بياناتك، يرجى الاتصال بنا عبر:",
            contact: {
                emailHeading: "بريد إلكتروني",
                phoneHeading: "هاتف",
                addresHeading: "عنوان",
                email: "hello@bitsclan.com",
                phone: "+1 315 666 8052",
                address: "نيويورك، 2 بارك أفينيو، الطابق 20، نيويورك، NY 10016",
            },
        },
    ],
};